// src/components/ScrollToTop.jsx
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop({ targetSelector = ".main" }) {
    const location = useLocation();

    useLayoutEffect(() => {
        const target = document.querySelector(targetSelector);

        if (target) {
            target.scrollTo({
                top: 0,
                left: 0,
                behavior: "auto",
            });
        } else {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "auto",
            });
        }

        // Falls mobil die Sidebar offen ist, beim Seitenwechsel schließen
        document.body.classList.remove("sidebar-open");
    }, [location.pathname, location.search, targetSelector]);

    return null;
}